const escapeRegex = (string) => {
    return string.replace(/[-\\*+?.()|[\]{}]/g, '\\$&');
}

export { escapeRegex }
